import type {
  AnalyticsConsentCategory,
  AnalyticsProviderKey,
} from '@/shared/schemas/analyticsConfig.schema'

export type { AnalyticsConsentCategory, AnalyticsProviderKey }

export type AnalyticsProviderConfig = Readonly<Record<string, string | number | boolean>>

export type AnalyticsEventValue = string | number | boolean

export type AnalyticsEventProps = Readonly<Record<string, AnalyticsEventValue>>

export interface AnalyticsProvider {
  readonly key: AnalyticsProviderKey
  load(config: AnalyticsProviderConfig): void
  unload(): void
  pageview(path: string): void
  track(name: string, props?: AnalyticsEventProps): void
}

export type AnalyticsConsentState = Readonly<Record<AnalyticsConsentCategory, boolean>>

export function configString(config: AnalyticsProviderConfig, field: string): string {
  const value = config[field]
  return typeof value === 'string' ? value : typeof value === 'number' ? String(value) : ''
}

declare global {
  interface Window {
    umami?: { track: (...args: unknown[]) => void }
    plausible?: ((...args: unknown[]) => void) & { q?: unknown[][] }
    _paq?: unknown[][]
    dataLayer?: unknown[]
    gtag?: (...args: unknown[]) => void
  }
}
